import { render } from "./DomainsTableComponent.vue?vue&type=template&id=288e69e9"
import script from "./DomainsTableComponent.vue?vue&type=script&lang=js"
export * from "./DomainsTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__